import esLocal from 'vant/lib/locale/lang/es-ES'
import esJame from './languageJame/es'
import esGaea from './languageGaea/es'
const es = {
  300000: '新年送礼',
  300001: '2022新年送礼',
  300002: 'SuperEx和你一起过新年',
  300003: '尊敬的SuperEx用户：<br>为庆祝SuperEx在新年之际盛大上线,<br>平台将随机空投送出价值1,000,000 USDT新年大礼包。 <br>具体活动如下：',
  300004: '活动时间<br>加拿大时间：2022年01月01日00：00-02月15日23：59',
  300005: '活动一：分享海报获空投',
  300006: '分享活动海报至＞1000人的telegram加密货币群组，并附言“百万豪礼大派送，SuperEx和你一起过新年！或分享活动海报至个人Tiwwer，置顶并附言“百万豪礼大派送，SuperEx和你一起过新年！ ”上传截图给客服，将有机会获得5 ET（价值5 USDT）。',
  300007: '活动二：邀新获VIP',
  300008: '获得期间，用户通过邀请好友新注册并成功入金≥100 USDT即为有效邀请人数。成功邀请人数越多，所获VIP等级越高。有效期（30天）',
  300009: '活动三：新用户充值送',
  300010: '活动期间，新注册用户净充值金额达到一下区间并完成一笔交易，即可获得ET奖励。 （净充值金额在活动结束前以USDT结算）活动期间，新注册用户净充值金额达到一下区间并完成一笔交易，即可获得ET奖励。 （净充值金额在活动结束前以USDT结算）',
  300011: '注意事项：',
  300012: '1.每位参与用户只能获得一次奖励 <br>2.所有参与用户默认遵守SuperEx服务条款，如发现违规将立即停止其活动资格 <br>3.SuperEx有权在不提早通知用户的情况下修改本次活动的条款 <br>4.SuperEx将取消不合规用户活动参与资格并停用相关SuperEx账户使用 <br>5.SuperEx保留本次活动最终解释权',
  300013: '立即分享',
  300014: 'SuperEx团队',
  300015: '2022年01月01日',
  300016: '更多信息关注SuperEx官网：SuperEx.com',
  300017: '净充值金额（{coin}）',
  300018: '奖励金（{coin}）',
  300019: '180天',
  300020: '净充值=总入金金额-总出金金额',
  300021: 'ET持仓数量',
  300022: 'Maker/Taker',
  300023: '有效邀请人数',
  300024: '赠送有效期',
  300025: '活动获取条件',
  300026: '注：所有赠送的VIP等级均无需ET持仓要求。 ',
  300027: 'Copiado exitoso ',
  300028: 'Error en la copia',

  300029: 'Descargar SuperEx APP',
  300030: 'Opere en cualquier momento y lugar',
  300031: 'Crear Cuenta SuperEx',
  300032: '若您已有SuperEx账户，请先登录',
  300033: 'Correo electrónico',
  300034: 'Móvil',
  300035: 'Número de móvil',
  300036: 'Contraseña ',
  300037: 'ID de referencia (opcional)',
  300038: 'He leído y estoy de acuerdo',
  300039: 'Términos de servicio de la SuperEx',
  300040: 'Soy mayor de 18 años y acepto los Términos de la SuperEx',
  300041: 'Registrarse',
  300042: 'Verificación de Seguridad ',
  300043: 'Seleccionar código de área',
  300044: 'Buscar',
  300045: 'Introduce tu número de teléfono móvil',
  300046: 'Por favor ingrese correctamente el número de móvil ',
  300047: 'Introduce tu dirección de correo electrónico',
  300048: 'Por favor ingrese un correo electrónico válido ',
  300049: 'Introduce tu contraseña',
  300050: 'Al menos 8 caracteres, incluidas letras mayúsculas y números',
  300051: 'Código de verificación de correo electrónico ',
  300052: 'Código de verificación del teléfono',
  300053: 'Autorización de Google/Microsoft',
  300054: 'Google/Microsoft',
  300055: 'Para la seguridad de su cuenta, complete las siguientes operaciones de verificación',
  300056: 'Presentar',
  300057: 'El código de 6 dígitos se enviará a {phone}',
  300058: 'El código se enviará a {email}',
  300059: 'Introduzca el código de verificación SuperEx/Google/Microsoft de 6 dígitos',
  300060: 'Introduce el código de verificación de 6 dígitos',
  300061: 'Enviar código',
  300062: 'Reenviar en {timeout} segundos',
  300063: 'Idioma',
  300064: 'Bajo revisión ',
  300065: 'Introduce letras en inglés o signos de puntuación comunes',


  300066: 'Centro de tareas',
  300067: 'Batalla de clasificación de reembolsos',
  300068: '¡Reclama hasta <em class="bold normal" style="font-size: 1.2rem;color: #FFC72B;">1BTC</em>!',
  300069: 'Invitar',
  300070: 'Tabla de clasificación',
  300071: 'Reglas de desbloqueo',
  300072: 'Recibe más ET',
  300073: 'Batalla de clasificación de reembolsos. ¡Hasta 1 BTC esperándote!',
  300074: 'Completa la transacción para desbloquear ET',
  300075: 'Completa todas las tareas anteriores para obtener la lista blanca y SuperEx lanzará al azar una gran cantidad de tokens ET a los usuarios de la lista blanca de vez en cuando.',
  300076: 'Clasificación diaria',
  300077: 'Clasificación total',
  300078: 'Términos de servicio',
  300079: 'Mis recompensas',

  300080: 'Cantidad de bloqueo',
  300081: 'Cantidad de desbloqueo',
  300082: 'Cantidad de desbloqueo = tarifa de negociación * dificultad de desbloqueo / precio ET',
  300083: 'Ir al comercio',
  300084: 'Ranking',
  300085: 'Cuenta',
  300086: 'Comisión',
  300087: 'Nota: La clasificación diaria se calcula hasta las 0:00 del día (UTC-4), y las recompensas se emitirán al día siguiente. Puede haber errores en los datos solo como referencia.',
  300088: 'Nota: Las recompensas se emitirán dentro de los 3 días hábiles posteriores a la finalización del evento, y los datos pueden tener errores solo como referencia.',
  300089: 'Ver más',

  300090: 'Conclusión',
  300091: '¡Ya eres un usuario de la lista blanca!',
  300092: 'Introduce tu cuenta de {type}',
  300093: 'Paso final',
  300094: 'Síguenos en Twitter',
  300095: 'Únete a nuestro grupo oficial de Telegram',
  300096: 'Iniciar depósito',
  300097: 'Iniciar la transición puntual',
  300098: 'Introduce inmediatamente la transacción de futuros',
  300099: 'Presenta a un amigo para que se registre',

  300100: 'Invitar a un amigo a comerciar',
  300101: 'Recomendar a un amigo que opere más',
  300102: 'Depósito',
  300103: 'Seguir',
  300104: 'Reclamación',
  300105: 'Recopilado (tiempos)',
  300106: 'Aún no está abierto',
  300107: 'Unirse',
  300108: 'No se han encontrado registros',
  300109: 'Completado',
  300110: 'Invita amigos y recibe más SCS',
  300111: 'Cancelar',
  300112: 'Presentar',
  300113: 'Faltan los artículos necesarios',
  300114: 'Actualmente no hay tareas',
  300115: 'Estén atentos a más tareas',
  300116: '¡Estén atentos a más eventos!',
  300117: 'Introduce tu cuenta',
  300118: 'Introduce tu cuenta',
  300119: 'Denegado',
  300120: 'Regístrate instantáneamente en SuperEx',
  300121: 'Regístrate',
  300122: 'Caducado',
  300123: 'Whitepaper',

  300124: 'Caja misteriosa',
  300125: 'Reciba una recompensa de 1000 USDT en la Caja Cripto Misteriosa con una tasa ganadora del <em class="normal bold" style="color: #FFC72B">100%</em>',
  300126: 'Reglas',

  300127: 'Abrir caja misteriosa',
  300128: 'Número de sorteos',
  300129: 'Restante (mío)',
  300130: 'Abierto (Total USDT)',
  300131: 'Recompensas',
  300132: '¿Cómo participar?',
  300133: 'Comparte tu enlace de invitación',
  300134: 'Completar tareas',
  300135: 'Invita a tus amigos a registrarse y completar tareas comerciales.',
  300136: 'Recibir Caja Misteriosa',

  300137: 'Completa tareas y obtén la caja misteriosa',
  300138: 'Este evento ha terminado, ¡espera con ansias el próximo evento!',
  300139: 'Este evento aún no ha comenzado, ¡así que estate atento!',
  300140: 'Reglas del evento',
  300141: 'Listo',
  300142: 'Hora',
  300143: '',
  300144: '',
  300145: 'Invitar amigos',
  300146: 'Enciende las linternas y diviértete con <em class="normal" style="color: #FFC72B">Halloween</em> ',
  300147: 'Inicia sesión durante <em class="normal" style="color: #FFC72B">{num}</em> días consecutivos y ten la oportunidad de ganar el premio <em class="normal" style="color: #FFC72B">{amount} ET</em>',
  300148: 'Lista de ganadores',
  300149: 'Registro diario de sesión',

  300150: 'Has iniciado sesión {num} días',
  300151: 'Sorteo de premios',
  300152: 'Iniciada sesión',
  300153: 'Iniciar sesión',
  300154: '',
  300155: '',
  300156: 'Iniciar sesión',
  300157: 'Recibí un comprobante de crédito de la tarifa del contrato',
  300158: 'Actualización VIP exitosa',
  300159: 'Tener la oportunidad de ganar la lotería',

  300160: 'Cupón de tarifa del contrato',
  300161: 'Actualización VIP',
  300162: '',
  300163: 'Tienes <em class="normal" style="color: #FFC72B">{num}</em> veces de volver a tener oportunidades',
  300164: 'Ten la oportunidad de iniciar sesión',
  300165: 'Puede volver a iniciar sesión',
  300166: 'Consejos',
  300167: 'Volver a iniciar sesión con éxito',
  300168: 'Todavía no tienes el número de inicios de sesión, puedes obtener 1 re-inicio para un depósito neto de ≥{num} {symbol} el mismo día.',
  300169: 'Iniciar sesión',

  300170: 'Has alcanzado el límite de re-inicios de sesión',
  300171: 'Lista de ganadores de usuarios que han iniciado sesión durante 7 días consecutivos',
  300172: 'Inicia sesión continuamente para obtener las siguientes recompensas',
  300173: 'Reclamado',
  300174: '{num} Días',
  300175: 'Cupón',
  300176: 'Mi Nivel VIP',
  300177: 'Participar en la lotería',
  300178: '¡Enhorabuena!',
  300179: 'Iniciar sesión con éxito',
  300180: '',
  300181: 'Academia',
  300182: 'Noticias',
  300183: 'Información',
  300184: 'Aprende',
  300185: 'Echa un vistazo con profundidad a los principales acontecimientos de la industria criptográfica global',
  300186: 'Obtenga una visión general rápida de los últimos eventos en la industria criptográfica de todo el mundo',
  300187: 'Aprende todo sobre blockchain, Web3 y criptomonedas',
  300188: 'Leer más',
  300189: 'Videos',
  300190: 'Cargando',
  300191: 'Todo cargado',
  300192: 'Todo',
  300193: 'El Torneo no ha comenzado',
  300194: 'Elige al ganador de la Copa del Mundo para ganar el <em class="normal" style="color:#DBFF00">bono</em> limitado',
  300195: 'Hora del Evento',
  300196: 'Registro de Votación',
  300197: 'Fase de Grupos',
  300198: '{num} Grupo',
  300199: 'Bolsa de Premios: {num}',
  300200: 'Voto',
  300201: 'Fase de Eliminación Directa',
  300202: 'Competencia',
  300203: 'Fecha límite para votar',
  300204: 'Votar',
  300205: 'Por favor introduzca el número de voto',
  300206: 'Número mínimo de apuestas: {num}ET',
  300207: 'Tiempo de Predicción',
  300208: 'Apostar por los equipos',
  300209: 'Votos',
  300210: 'Importe del Premio',
  300211: 'Equipos Clasificados',
  300212: 'D',
  300213: 'H',
  300214: 'M',
  300215: 'S',
  300216: 'Horarios',
  300217: 'El Evento aún no ha comenzado',
  300218: '1/4 Final',
  300219: 'Confirmar',
  300220: 'Número de Voto',
  300221: 'Equilibrio insuficiente',
  300222: 'Depósito',
  300223: 'Predicción Exitosa',
  300224: '1/8 Final',
  300225: 'Semifinal',
  300226: 'Finalistas del tercer y cuarto lugar',
  300227: 'Final',
  300228: 'Victoria',
  300229: 'Derrota ',
  300230: 'Total de Bolsa de Premios:{num} ET',
  300231: 'Ver Más Partidos',
  300232: 'Otras Competiciones',
  300233: 'Moneda',
  300234: 'Precio de mercado',
  300235: '% de cambio 24h',
  300236: 'Guía para nuevos usuarios',
  300237: 'Empieza a aprender el comercio de divisas digitales ahora',
  300238: 'Presencia global',
  300239: 'Sin fronteras, descentralización comunitaria y autonomía, la descentralización de equipos es la forma definitiva de desarrollo de SuperEx',

  300240: 'Riesgo de seguridad cero',
  300241: 'SuperWallet descentralizado está integrado y la clave privada se cifra y almacena en el dispositivo del usuario. No se ve afectado por la seguridad del código, la política y otros factores',
  300242: 'Sin registro y KYC ',
  300243: 'Transacciones autorizadas por la cartera, sin registro, sin KYC, las liquidaciones de transacciones se completan en la cadena, no se pueden manipular, son seguras y transparentes',
  300244: 'Sistema abierto ',
  300245: 'Permitir a los usuarios interactuar con Dapp o contratos inteligentes, al abrir SuperWallet, los usuarios pueden ser autorizados a participar en Meta, DeFi y NFT',
  300246: 'Fondo Espacial',
  300247: 'El Fondo Espacial se utiliza para la exploración humana del espacio o para financiar instituciones o personas que han hecho contribuciones significativas a la exploración humana del espacio',
  300248: 'Un intercambio seguro y fácil de usar',
  300249: 'Descarga la aplicación móvil SuperEX para vigilar los mercados y realizar operaciones en el momento perfecto, estés donde estés.',

  300250: 'Más descargas',
  300251: 'Cada operación que haces es combustible para que los humanos vuelen al espacio',
  300252: 'Registrarse ahora',
  300253: 'Escaneo de iOS y Android para descargar',
  300254: 'Autenticador',
  300255: 'El autenticador generará un código de verificación en 2 pasos para ti. Mantén tu cuenta de SuperEx aún más segura con la verificación en 2 pasos.',
  300256: 'Autenticador de SuperEx',
  300257: 'Autorización de Google',
  300258: 'Autorización de Microsoft',
  300259: 'Descargar cliente (iPhone)',

  300260: 'Descargar cliente (Android)',
  300261: '¡La plataforma de comercio de activos digitales más segura del mundo!',
  300262: 'Acerca de nosotros ',
  300263: 'Términos ',
  300264: 'Privacidad',
  300265: 'Anuncios',
  300266: 'Academia',
  300267: 'Centro de Principiantes',
  300268: 'Comercio spot',
  300269: 'Futuros',

  300270: 'FAQ',
  300271: 'Servicio',
  300272: 'Tasas',
  300273: 'Reglas',
  300274: 'Aplicación de Listado',
  300275: 'Recomendación ',
  300276: 'Contáctenos ',
  300277: 'Centro de Ayuda',
  300278: 'Enviar una solicitud',
  300279: 'Contactos comerciales',

  300280: 'Cooperación institucional',
  300281: 'Más',
  300282: '¡Bienvenido de nuevo!',
  300283: '¿Olvidó la contraseña?',
  300284: '¿Todavía no tienes una cuenta?',
  300285: 'Ve a la aplicación o al ordenador para recuperar la contraseña',
  300286: 'Ok',

  300287: 'Confirmar ',
  300288: 'Por anunciar',
  300289: 'Para ser reclamado',

  300290: 'Ya se ha Unido',
  300291: 'Ya fue Reembolsado',
  300292: 'Reglas de Compra',
  300293: "Comprar <span style='color: #ffc72b;'>Bienes</span>",
  300294: 'Elegir y Comprar',
  300295: 'Esperando Resultados',
  300296: 'Reclamar el Artículo',
  300297: 'Depósito',
  300298: 'Registro de Compra',
  300299: 'Lista de Artículos',
  300300: 'Cuota de participación única',
  300301: 'Se han vendido {num} copias. El artículo se venderá después de llegar a {price} {currency}.',
  300302: 'Únete Ahora',
  300303: 'Únete de Nuevo',
  300304: 'Seleccione el número de copias para comprar',
  300305: "1 copia requiere <span style='color: #fa4d56;'>{minPrice} {currency}</span>, y se puede comprar un solo artículo como máximo <span style='color: #fa4d56;'>{maxBuyCount} copias</span>",
  300306: 'copias',
  300307: 'Tienes {num} {currency}, ¡Cuantas más copias compres, mayores serán las posibilidades de ganar!',
  300308: 'Comprar',
  300309: 'La Próxima Vez',
  // 300309: '余额充值',
  300310: '¡Enhorabuena!',
  300311: 'Reclamación',
  300312: '¡Inténtalo de nuevo!',
  300313: 'Completa el depósito de cripto o P2P en la APP.',
  // 300314: '我知道了',
  300315: 'Póngase en contacto con el servicio de atención al cliente en la aplicación para reclamar el artículo.',
  // 300316: '我知道了',
  300317: 'Iniciar sesión / Registrarse',
  300318: 'Costo {num} {currency}',
  300319: 'Descripción del artículo',
  300320: 'Mi participación',
  300321: 'Hora',
  300322: 'Artículos participantes',
  300323: 'Número de copias compradas',
  300324: 'Importe del reembolso',
  300325: 'Funcionamiento',
  300326: 'Reclamación',
  300327: '¿Ya tienes una cuenta?',
  300328: 'Iniciar sesión',
  300329: 'Código de auth',
  300330: 'Solo se muestran los últimos siete días de registros',
  300331:'Autenticador',
  300332:'Descargar',
  300333:'1USDT puede comprar 1Bitcoin',
  300334:"Precio de Compra",
  300335:"Resultados Previos",
  // 300336:"期次",
  300337:"Ver Reglas",
  300338:"Problema: [Fase {num}]",
  300339:"Proceso de Compra",
  300340:"Usuarios Comprados con Éxito",
  300341:"Hora del anuncio",
  300342:"Compartir ",
  300343:"Problema [{num}]",
  300345:"Descargar ",
  300346:"Comparte tu alegría",
  300347:"Escanea El Código Para Unirte",
  300348:"Reclamar el Artículo",
  300349:"Nota: Los artículos de la moneda digital se enviarán a su cuenta en un plazo de 48 horas.",
  300350:"Póngase en contacto con el servicio de atención al cliente para reclamar otros artículos",
  300351:"Ir a ver",
  300352:"Registrarse Ahora ",
  300353:"Registrado ",
  300354:'Registro Cerrado',
  300355:'Registro Exitoso ',
  300356:'abre la aplicación',
  300357:'¡Enhorabuena a {user} por adquirir {shop}!',
  300358:'Centro de Eventos',
  300359:'En curso',
  300360:'Empezando pronto',
  300361:'Terminado',
  300362:'Únete ahora',
  300363: 'Terminado',
  300364: 'Ganadores',
  300365: 'Los ganadores se anunciarán pronto',



  310000:'Descripción general de la recompensa',
  310001:'SCS Entrega por paracaídas',
  300366: 'Moneda',
  300367: 'Vender',
  200368: 'Pagar',
  300369: 'Recibir',
  300370: 'Conseguir',
  300371: 'Límite de transacción única:',
  300372: 'Método de pago',
  300373: 'Método de pago',
  300374: 'Proveedor de pagos',
  300375: 'Detalles del pedido',
  300376: 'Importe (incluidas las tarifas de transacción)',
  300377: 'Hora de llegada',
  300378: 'No responsabilidad',
  300379: 'He leído y acepto el descargo de responsabilidad',
  300380: "Dejarás SuperEx y saltarás a <span>{name}</span>, una institución financiera con licencia que proporciona capacidades de pago con tarjeta como un tercero. Cualquier evento de riesgo que ocurra durante el uso será soportado por <span>{name}</span>. Por favor, lea y acepte el <a class= 'pointer' href={server}>Acuerdo de Servicio</a> de <span>{name}</span> antes de usar sus servicios Si tiene alguna pregunta sobre el depósito con tarjeta de crédito, póngase en contacto con <a class='pointer' href={Customer}>{name} Servicio de Atención al Cliente</a> para obtener más detalles.",
  300381: '¿Cómo comprar criptomonedas en SuperEx?',
  300382: 'Cómo vender criptomonedas en SuperEx?',
  300383: 'Haga su pedido de criptomonedas',
  300384: 'Elige la moneda fiat con la que quieres pagar y la criptomoneda que quieres comprar. Introduzca la cantidad que desea gastar.',
  300385: 'Verifica tu identidad',
  300386: 'Complete la verificación KYC en SuperEx y el proveedor de pagos para completar el pago.',
  300387: 'Comprueba los detalles de tu pedido',
  300388: 'Compruebe su historial de depósitos para ver el estado de su pedido.',
  300389: 'FAQ',
  300390: '1. ¿Qué métodos de pago puedo usar para comprar criptomonedas?',
  300391: 'SuperEx actualmente es compatible con VISA, Mastercard, Apple Pay, Google Pay y otros métodos de pago. Los proveedores de servicios de terceros compatibles incluyen Mercuryo y alchemypay.',
  300392: '2. ¿Qué criptomonedas puedo comprar?',
  300393: 'SuperEx es compatible con las principales criptomonedas como BTC, ETH, USDT, LTC, USDC, XRP, BCH, CRV y TRX.',
  300394: '3. ¿SuperEx supervisa la calidad y los precios de los proveedores de servicios externos compatibles?',
  300395: 'SuperEx ha seleccionado cuidadosamente una serie de proveedores de servicios con reputación, popularidad y seguridad de confianza en la industria para proporcionar a los usuarios servicios optimizados.',
  300396: '4. ¿Qué tarifas tengo que pagar para comprar criptomonedas?',
  300397: 'Usted paga una tarifa al proveedor de servicios externo y una tarifa de transferencia en cadena. SuperEx no cobra ninguna tarifa.',
  300398: '5. ¿Cuánto tiempo se tarda en recibir la criptomoneda después del pago?',
  300399: 'Después de que se complete su pago en la plataforma de proveedores de servicios de terceros, su criptomoneda se depositará en su cuenta al contado en SuperEx en unos 2 a 10 minutos.',
  300400: '6. ¿Qué pasa si tengo problemas durante el proceso de compra?',
  300401: 'Póngase en contacto con el servicio de atención al cliente si tiene algún problema durante el proceso de transacción. Si no ha recibido la criptomoneda después de que se complete el pago, póngase en contacto con el proveedor de servicios externo para comprobar los detalles del pedido (este suele ser el método más eficiente). Debido a la propiedad intelectual de su región actual o a ciertas razones de política, tendrá que seleccionar la verificación humana.',
  300402: "Disponible",
  300403: 'No hay suficiente balance',
  300404: 'Please enter currency',
  300405: 'Introduzca la moneda fiduciaria',
  300406: 'No has completado la verificación de identidad',
  300407: "Para la seguridad de su cuenta con otros usuarios comerciales, complete primero la verificación de identidad",
  300408: 'Obtener la Verificación',
  300409: 'Sin verificar',
  300410: 'Elegir moneda',
  300411: 'Elige la moneda fiduciaria',
  300412: 'All currencies',
  300413: 'Todas las monedas fiduciarias',
  300414: '≈{time} minutos',
  300415: 'El comercio P2P no está abierto a los usuarios autorizados de la cartera en este momento, utilice su cuenta de SuperEx para iniciar sesión y comerciar con P2P',
  300416: 'https://support.superex.com/hc/en-001/articles/23084120565017',
  300417:'Comprar',
  300418: 'Número de serie',
  300419: 'Carnaval de Halloween SuperEx',
  300420: '¡Inten sesión para disfrutar de regalos y comercia para ganar bonos!',
  300421:'Tipo',
  300422:'Recompensas por criptomonedas',
  300423:'',
  300424:'',

  400000:'Primer Exchange de Criptomonedas Web3',
  400001:'Únete a nosotros para crear un mundo financiero',
  400002:'Cada operación que haces es combustible para que los humanos vuelen al espacio',
  400003:'La emocionante revisión de superex',
  400004:'Compromiso activo y sonrisas compartidas: La historia de nuestro muro de actividades',
  400005:'Selecciona Idioma y Región',
  400006:'0 RIESGO',
  400007:'SIN KYC',
  400008:'ABIERTO',
  400009:'FONDO',
  400010:'Explorar Mainnet',
  400011:'Explorar Testnet',
  400012:'Documentos del Desarrollador',
  400013:'Other',
  400014:'Zona ET',
  400015:'',

  ...esLocal,
  ...esJame,
  ...esGaea
}
export default es;



// WEBPACK FOOTER //
// ./src/i18n/langs/es.js